<template>
	<div class="open_review">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">结题审核</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
												
												<ul class="tabs_wrap">
													<li class="tab_item" :class="{active:index == curTabIndex}" @click="tabChange(index)" v-for="(item,index) in tabList" :key="index">{{item}}</li>
												</ul>
												
												<el-form ref="reviewQueryFormRef" :model="reviewQueryForm" label-width="0px">
													<el-row :gutter="10">
														<el-col :span="3">
															<el-form-item><el-input placeholder="课题名称,负责人,学校" v-model="reviewQueryForm.keyWord"></el-input></el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item>
																<el-cascader
																	v-model="reviewQueryForm.keywordId"
																	:options="TopicLevelTypeList"
																	:props="{ checkStrictly: true,value:'id',label:'name' }"
																	 placeholder="课题级别类别"
																	 @change="keywordIdChange"
																	clearable></el-cascader>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item>
																<el-select v-model="reviewQueryForm.learningType" clearable placeholder="所属学段">
																	<el-option v-for="item in learningTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item>
																<el-select v-model="reviewQueryForm.disciplineId" clearable placeholder="所属学科">
																	<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item><el-date-picker v-model="reviewQueryForm.year" value-format="yyyy" type="year" placeholder="立项年度"></el-date-picker></el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item>
																<!-- <el-select v-model="reviewQueryForm.name" clearable placeholder="审核状态">
																	<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
																</el-select> -->
																<el-select v-model="queryReviewStatus" clearable placeholder="审核状态" @change="reviewStatusChange">
																	<el-option v-for="(item, index) in options" :key="index" :label="item" :value="item"></el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="6">
															<el-form-item>
																<el-button type="primary" @click="searchReviewList">查询</el-button>
																<el-button type="success" @click="exportExcel('school')">导出Excel</el-button>
															</el-form-item>
														</el-col>
													</el-row>
												</el-form>

												<!-- <div class="stat mb20" v-if="tabList[curTabIndex]=='区级审核'">数据统计：未开题：{{reviewPhaseStat.oneTotalNumber}}，已开题：{{reviewPhaseStat.twoTotalNumber}}</div> -->

												<el-table id="table" :header-cell-style="tableStyle" :data="reviewTopicList" border style="width: 100%;margin-bottom: 20px;">
													<el-table-column prop="projectNumber" label="立项编号" width="100px"></el-table-column>
													<el-table-column prop="declareName" label="课题名称">
														<template v-slot="scope">
															<el-tooltip class="item" effect="dark" :content="scope.row.declareName" placement="top">
																<div class="multi-line-ellipsis">{{scope.row.declareName}}</div>
															</el-tooltip>
														</template>
													</el-table-column>
													<el-table-column prop="projectTypeName" label="课题类别" width="100px"></el-table-column>
													<el-table-column prop="learningTypeName" label="学段" width="60px"></el-table-column>
													<el-table-column prop="disciplineName" label="学科" width="60px"></el-table-column>
													<el-table-column prop="oneUnitName" label="单位"></el-table-column>
													<el-table-column prop="oneEmceeName" label="负责人" width="80px"></el-table-column>
													<el-table-column prop="isSubmit" label="提交状态" width="80px">
														<template v-slot="scope">
															{{scope.row.isSubmit?'已提交':'未提交'}}
														</template>
													</el-table-column>
													<el-table-column prop="status" label="审核状态">
														<template v-slot="scope">
															{{scope.row.status|getTopicStage}}
														</template>
													</el-table-column>
													<el-table-column prop="address" label="操作" width="110px">
														<template v-slot="scope">
															<el-button type="primary" v-if="isShowReviewBtn(scope.row)" @click="goReviewPage(scope.row.id)">审核</el-button>
														</template>
													</el-table-column>
												</el-table>
												<div class="pagination">
													<el-pagination
														@size-change="sizeChange"
														@current-change="currentChange"
														:current-page="reviewQueryForm.pageNumber"
														:page-sizes="[10, 20, 50, 100]"
														:page-size="reviewQueryForm.pageSize"
														layout="total, sizes, prev, pager, next, jumper"
														:total="reviewTopicTotal">
													</el-pagination>
												</div>
												
												<div class="btn_wrap">
													<el-button type="primary" @click="exportReportFile">导出报告附件</el-button>
												</div>
												
												
												
										
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb.vue';
import { reviewList,getReviewPhaseStat,getReportFile } from '@/api/after/topicManage.js'
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			queryReviewStatus:null,
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			// 学段列表
			learningTypeList: [
				{
					value: 0,
					label: '幼儿园'
				},
				{
					value: 1,
					label: '小学'
				},
				{
					value: 2,
					label: '初中'
				},
				{
					value: 3,
					label: '高中'
				},
				{
					value: 4,
					label: '高/中职'
				},
				{
					value: 5,
					label: '其他'
				}
			],
			disciplineOptions:[],//学科列表
			TopicLevelTypeList:[],//课题级别类别
			curTabIndex:0,//
			tabList:[],//学校审核区域审核tab
			keywordId:'',//级别或类别id
			reviewQueryForm: {
				auditType:0,//审核类型(0:学校审核,1:区级审核
				disciplineId:'',//所属学科id
				keyWord:'',//关键字
				keywordId:'',//级别或类别id
				learningType:'',//所属学段类型(0:幼儿园，1:小学,2:初中,3:高中,4:高/中职,5:其他)
				pageNumber:1,//页码,默认为1,示例值(1)
				pageSize:10,//页大小,默认为10,示例值(10)
				type:3,//类型(0:开题,1:中期,2:结题申请,3:结题)
				year:'',//立项年度
			},
			options: ['未审核','未通过'],
			activeName: 'first',
			reviewTopicList: [],//课题列表
			reviewTopicTotal:0,
			// areaReviewTopicList:[],//区级审核列表
			// areaReviewTopicTotal:0,
			// isBanSchool:false,//是否禁用校审核
			// isBanArea:false,//是否禁用区审核
			userinfo:JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
			reviewPhaseStat:{},//结题阶段统计
		};
	},
	computed:{
		isShowReviewBtn(data){
			return data=>{
				let curReviewLevel = this.tabList[this.curTabIndex]
				if (curReviewLevel == '学校审核') {
					if (data.isSubmit && data.status==16) {
						return true
					}else{
						return false
					}
				}else if (curReviewLevel == '区级审核') {
					if (data.isSubmit && data.status==18) {
						return true
					}else{
						return false
					}
				}
			}
		}
	},
	created() {
		this.getDiscipline()
		this.getTopicLevelType()
		// this.getReviewPhaseStat()
		// 根据当前用户角色禁用审核功能
		if (Object.keys(this.userinfo).length) {
			if (this.userinfo.roleId.indexOf('2') >= 0) {
				// this.$set(this.tabList,0,'学校审核')
				this.tabList.push('学校审核')
			}
			if (this.userinfo.roleId.indexOf('5') >= 0) {
				// this.$set(this.tabList,1,'区级审核')
				this.tabList.push('区级审核')
			}
		}else {
			this.$message.warning('删除错误!')
			this.$router.push('/index')
		}
		if (this.tabList[0]=='学校审核') {
			this.reviewQueryForm.auditType = 0
		}else if (this.tabList[0]=='区级审核') {
			this.reviewQueryForm.auditType = 1
		}
		if (sessionStorage.getItem('pageNumber') && sessionStorage.getItem('auditType')) {
			this.reviewQueryForm.pageNumber = parseInt(sessionStorage.getItem('pageNumber'));
			this.reviewQueryForm.auditType = parseInt(sessionStorage.getItem('auditType'));
			this.curTabIndex=this.reviewQueryForm.auditType;
			sessionStorage.removeItem('pageNumber');
			sessionStorage.removeItem('auditType');
		}
		this.getReviewList(this.reviewQueryForm)
	},
	methods: {
		// 审核状态改变
		reviewStatusChange(){
			if (this.queryReviewStatus) {
				let curReviewLevel = this.tabList[this.curTabIndex]
				if (curReviewLevel === '学校审核') {
					if (this.queryReviewStatus === '未审核') {
						this.reviewQueryForm.status = 16
					}else if (this.queryReviewStatus === '未通过') {
						this.reviewQueryForm.status = 17
					}
				}else if (curReviewLevel === '区级审核') {
					if (this.queryReviewStatus === '未审核') {
						this.reviewQueryForm.status = 18
					}else if (this.queryReviewStatus === '未通过') {
						this.reviewQueryForm.status = 19
					}
				}
			}else{
				this.reviewQueryForm.status = null
			}
		},
		tabChange(index){
			if (this.curTabIndex == index) {
				return 
			}
			this.curTabIndex = index
			if (this.tabList[index] == '学校审核') {
				this.reviewQueryForm.auditType = 0
			}else if (this.tabList[index] == '区级审核') {
				this.reviewQueryForm.auditType = 1
			}
			this.reviewQueryForm.pageNumber = 1
			this.getReviewList(this.reviewQueryForm)
			this.reviewStatusChange()
		},
		// 导出报告附件
		async exportReportFile(){
			const res = await getReportFile(3)
			//创建一个a标签并实现下载功能
			const link = document.createElement('a');
			let blob = new Blob([res], { type: 'application/octet-stream' });//res是文件流
			link.style.display = 'none';
			link.href = URL.createObjectURL(blob);
			link.download = '结题报告附件.zip'; //下载的文件名
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		// 导出excel
		exportExcel(){
			let exportFileName;
			if (this.tabList[this.curTabIndex] == '学校审核') {
				exportFileName = '结题学校审核.xlsx'
			}else if (this.tabList[this.curTabIndex] == '区级审核') {
				exportFileName = '结题区级审核.xlsx'
			}
				var xlsxParam = { raw: true };
				var wb = XLSX.utils.table_to_book(
				  document.querySelector("#table"),
				  xlsxParam
				);
				var wbout = XLSX.write(wb, {
				  bookType: "xlsx",
				  bookSST: true,
				  type: "array",
				});
				try {
				  FileSaver.saveAs(
				    new Blob([wbout], { type: "application/octet-stream" }),
				    exportFileName
				  );
				} catch (e) {
				  if (typeof console !== "undefined") {
				    console.log(e, wbout);
				  }
				}
				return wbout;
		},
		// // 获取结题阶段的统计
		// async getReviewPhaseStat(){
		// 	const res = await getReviewPhaseStat(3)
		// 	if (res.code == 200) {
		// 		console.log('结题阶段统计',res);
		// 		this.reviewPhaseStat = res.data
		// 	}else{
		// 		this.$message.error(res.data)
		// 	}
		// },
		goReviewPage(id){
			if (this.tabList[this.curTabIndex] == '学校审核') {
				this.$router.push({path:'/backstage/concludingReviewSchoolReviewDetail',query:{id,auditType:this.reviewQueryForm.auditType,pageNumber:this.reviewQueryForm.pageNumber}})
			}else if (this.tabList[this.curTabIndex] == '区级审核') {
				this.$router.push({path:'/backstage/concludingReviewAreaReviewDetail',query:{id,auditType:this.reviewQueryForm.auditType,pageNumber:this.reviewQueryForm.pageNumber}})
			}
		},
		// 学校审核分页
		sizeChange(val){
			this.reviewQueryForm.pageSize = val
			this.getReviewList(this.reviewQueryForm)
		},
		currentChange(val){
			this.reviewQueryForm.pageNumber = val
			this.getReviewList(this.reviewQueryForm)
		},
		// 获取审核列表
		async getReviewList(data){
			
			const res = await reviewList(data)
			if (res.code == 200) {
				this.reviewTopicList = res.data.records
				this.reviewTopicTotal = res.data.total
			}else{
				this.$message.error(res.data)
			}
		},
		//课题级别类别筛选
		keywordIdChange(val){
			this.reviewQueryForm.keywordId=val.length?val[val.length - 1]:'';
		},
		// 搜索学校评审列表
		searchReviewList(){
			this.reviewQueryForm.pageNumber = 1
			this.getReviewList(this.reviewQueryForm)
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(8);
			if (res.code == 200) {
				console.log('学科',res);
				this.disciplineOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取课题级别类别目录
		async getTopicLevelType() {
			const res = await getPlatformInformationData(1);
			console.log('课题级别类别', res);
			if (res.code == 200) {
				this.TopicLevelTypeList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
	}
};
</script>

<style scoped lang="scss">
	.tabs_wrap{
		list-style: none;
		padding-left: 0px;
		display: flex;
		align-items: center;
		.tab_item{
			flex: 1;	
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
		}
		.tab_item.active{
			color:#00a2e8;
			border-bottom: 1px solid #00a2e8;
		}
	}
	.pagination{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
	}
::v-deep .el-date-editor.el-input {
	width: 100%;
}
</style>
